module.exports = __webpack_public_path__ + "img/h-min.16384e3e.jpg";